export {
  formatCatNames,
  formatPossessiveCatNames,
  formatPossessiveName,
} from "libs/i18n/src/lib/formatting";

export const pluralise = (singular: string, plural: string, count: number) => (count > 1 ? plural : singular);

export const trimTrailingSlashes = (value: string, minLength = 0): string => {
  let end = value.length;
  while (end > minLength && value[end - 1] === "/") {
    end--;
  }

  return value.slice(0, end);
};
